import { Section } from "../../AppStyle";
import {
  BorderLine,
  FlexCenter,
  FooterContent,
  SocialIcons,
} from "./FooterStyle";
import facebookIcon from "../../assets/images/facebook.png";
import instaIcon from "../../assets/images/instagram.png";

const Footer = () => {
  return (
    <Section color="#FFFFFF">
      <FooterContent>
        <div style={{ textAlign: "center" }}>
          <h5 style={{ margin: 0, fontWeight: 700 }}>How Can We Help You?</h5>
          <div style={{ marginTop: 15, fontWeight: 500, color: "#951211" }}>
            Email: ashbycustomdesigns@gmail.com
          </div>
          <div style={{ marginTop: 5, fontWeight: 500, color: "#951211" }}>
            Phone: (801) 725-1469
          </div>
        </div>
        <div className="socials" style={{ textAlign: "center" }}>
          <h5 style={{ margin: 0, fontWeight: 700 }}>Socials</h5>
          <FlexCenter>
            <a
              href="https://www.facebook.com/PB-Custom-Designs-103886852145836"
              target="_blank"
              rel="noreferrer"
            >
              <SocialIcons src={facebookIcon} alt="facebook icon" />
            </a>
            <a
              href="https://www.instagram.com/ashby.customdesigns/?hl=en"
              target="_blank"
              rel="noreferrer"
            >
              <SocialIcons src={instaIcon} alt="instagram icon" />
            </a>
          </FlexCenter>
        </div>
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h5 style={{ margin: 0, fontWeight: 700 }}>Links</h5>
          <a
            href="#about"
            style={{ marginTop: 15, fontWeight: 500, color: "#951211" }}
          >
            About Us
          </a>
          <a
            href="#work"
            style={{ marginTop: 5, fontWeight: 500, color: "#951211" }}
          >
            Our Work
          </a>
          <a
            href="#contact"
            style={{ marginTop: 5, fontWeight: 500, color: "#951211" }}
          >
            Contact Us
          </a>
        </div>
      </FooterContent>
      <BorderLine></BorderLine>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          margin: 20,
          marginBottom: 40,
        }}
      >
        <div style={{ color: "rgba(0, 0, 0, 0.5)" }}>
          P&B Custom Designs LLC 2021
        </div>
      </div>
    </Section>
  );
};

export default Footer;
